// extracted by mini-css-extract-plugin
export var quantityInput = "_p3-0";